import { client } from '../galaxyClient';

export async function getCurrentUser() {
  const { data } = await client.users.GET('/v2/me/', {});
  return data;
}
